// src/components/kanban/attachments/AttachmentPreviewModal.tsx
/**
 * Modal di anteprima per un allegato task: immagini a schermo intero, PDF in iframe,
 * fallback a download per gli altri tipi (o quando l'URL di anteprima non è disponibile,
 * es. storage locale in sviluppo).
 */
import { Button, Image, Modal, Stack, Text } from '@mantine/core';
import type { TaskAttachment } from '../../../types/api';

interface AttachmentPreviewModalProps {
  attachment: TaskAttachment | null;
  onClose: () => void;
}

export default function AttachmentPreviewModal({ attachment, onClose }: AttachmentPreviewModalProps) {
  return (
    <Modal opened={!!attachment} onClose={onClose} size="90%" title={attachment?.originalFileName} centered>
      {attachment?.isImage && <Image src={attachment.previewUrl ?? attachment.downloadUrl} fit="contain" mah="75vh" />}

      {attachment?.isPdf &&
        (attachment.previewUrl ? (
          <iframe
            src={attachment.previewUrl}
            title={attachment.originalFileName}
            style={{ width: '100%', height: '75vh', border: 0 }}
          />
        ) : attachment.downloadUrl ? (
          <Stack align="center" py="xl">
            <Text c="dimmed">Anteprima non disponibile</Text>
            <Button component="a" href={attachment.downloadUrl} target="_blank" rel="noopener noreferrer">
              Scarica
            </Button>
          </Stack>
        ) : (
          <Text c="dimmed" ta="center" py="xl">
            Apri il file dal pulsante Scarica nell'elenco allegati
          </Text>
        ))}

      {attachment && !attachment.isImage && !attachment.isPdf && (
        <Stack align="center" py="xl">
          <Text c="dimmed">Anteprima non disponibile per questo tipo di file</Text>
          {attachment.downloadUrl && (
            <Button component="a" href={attachment.downloadUrl} target="_blank" rel="noopener noreferrer">
              Scarica
            </Button>
          )}
        </Stack>
      )}
    </Modal>
  );
}
